import React from "react";
import { NavDropdown } from "react-bootstrap";
import { Link, graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { FaAngleDown } from "react-icons/fa";

const query = graphql`
  {
    allFile(filter: { relativeDirectory: { eq: "icon" }, ext: { ne: "svg" } }) {
      nodes {
        name
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, height: 20)
        }
      }
    }
  }
`;

const Elementos = ({ arreglo, nodes }) => {
  return arreglo.map((item, index) => {
    const pathToImage = getImage(nodes[item.icon - 1]);
    return (
      <NavDropdown.Item as="li" key={index}>
        <Link to={item.link} className="dropdown-item" activeClassName="active">
          <GatsbyImage image={pathToImage} alt={item.alt} />
          {item.title}
        </Link>
      </NavDropdown.Item>
    );
  });
};

const Sub = ({ title, arreglo, nodes }) => {
  return (
    <div className="dropdown-sub">
      <h6>{title}</h6>
      <Elementos arreglo={arreglo} nodes={nodes} />
    </div>
  );
};

const DropPersonas = () => {
  const data = useStaticQuery(query);
  const nodes = data.allFile.nodes;
  const NavDropdownTitle = (
    <>
      Productos <FaAngleDown />
    </>
  );
  return (
    <Wrapper title={NavDropdownTitle}>
      <Sub title="Personas" arreglo={prodPersonas} nodes={nodes} />
      <Sub title="Empresas" arreglo={prodEmpresas} nodes={nodes} />
      <Sub title="PYMES" arreglo={prodPymes} nodes={nodes} />
    </Wrapper>
  );
};

export default DropPersonas;

const Wrapper = styled(NavDropdown)`
  .show {
    left: -188px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 590px;
    @media (max-width: 991px) {
      flex-direction: column;
    }
  }
  .dropdown-sub {
  }
  .dropdown-item {
    img {
      width: 15px;
      margin-right: 8px;
    }
  }
`;
const prodPersonas = [
  {
    link: "/product-detail",
    alt: "Automovil",
    title: "Automóvil",
    icon: 1,
  },
  {
    link: "#",
    alt: "Gastos Médicos",
    title: "Gastos Médicos",
    icon: 2,
  },
  {
    link: "#",
    alt: "Vida",
    title: "Seguro de Vida",
    icon: 3,
  },
  {
    link: "/accident-quote",
    alt: "Accidentes",
    title: "Accidentes Personales",
    icon: 4,
  },
  {
    link: "#",
    alt: "hogar",
    title: "Seguro de Hogar",
    icon: 5,
  },
];

const prodEmpresas = [
  {
    link: "/auto-quote",
    alt: "Automovil",
    title: "Automóvil",
    icon: 1,
  },
  {
    link: "#",
    alt: "Gastos Médicos",
    title: "Gastos Médicos",
    icon: 2,
  },
  {
    link: "#",
    alt: "Empresarial",
    title: "Seguro Empresarial",
    icon: 6,
  },
  {
    link: "#",
    alt: "Maquinaria",
    title: "Maquinaria Pesada",
    icon: 7,
  },
];

const prodPymes = [
  {
    link: "/auto-quote",
    alt: "Automovil",
    title: "Automóvil",
    icon: 1,
  },
  {
    link: "#",
    alt: "Gastos Médicos",
    title: "Gastos Médicos",
    icon: 2,
  },
  {
    link: "#",
    alt: "Empresarial",
    title: "Seguro Empresarial",
    icon: 6,
  },
];
